import React from "react";
import Navbar from "../../component/Navbar";
import ElectricalComp from "../../component/solutionscomponent/ElectricalComp";
import Footer from "../../component/Footer";

const Electrical = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <ElectricalComp />
        <Footer />
      </section>
    </>
  );
};

export default Electrical;
